import { effect, inject, Injectable, signal } from '@angular/core';
import { RisikoOpkraevning } from '../risiko-opkraevning.model';
import { RisikoOpkraevningSearchParams } from './opkraevning-search/risiko-opkraevning-search-params.model';
import { RisikoOpkraevningDatasource } from './risiko-opkraevning.datasource';

@Injectable({
  providedIn: 'root',
})
export class RisikoOpkraevningerService {
  datasource = inject(RisikoOpkraevningDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedOpkraevning = signal<RisikoOpkraevning | undefined>(undefined);
  activeTab = signal('search');
  mode = signal('update');

  searchRisikoOpkraevning(searchParams: RisikoOpkraevningSearchParams) {
    this.selectedOpkraevning.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  async selectOpkraevningResultRow(risikoopkraevning: RisikoOpkraevning) {
    this.mode.set('update');
    await this.selectOpkraevning(risikoopkraevning);

    if (risikoopkraevning) {
      this.activeTab.set('detail');
    }
  }

  async selectOpkraevning(opkraevning: RisikoOpkraevning) {
    const r = await this.datasource.getById(opkraevning.id!);
    this.selectedOpkraevning.set(r);
  }
}
